import { CommonPropsAndTypes } from '../BaseComponents/_Types/StandardComponentProps';

/*
  Denna Hook användes för att skydda Utdelning av ekonomisk analys men numera användes om man vill ändra standard input typ
  Därav att denna Hook bara retunerar en string
*/

const useInputVariant = (): CommonPropsAndTypes.InputVariantType => {
  return 'outlined';
};

export default useInputVariant;
